import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=21dc8bc4&scoped=true&"
import script from "./ApplicationForm.vue?vue&type=script&lang=ts&"
export * from "./ApplicationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationForm.vue?vue&type=style&index=0&id=21dc8bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc8bc4",
  null
  
)

export default component.exports